/* eslint-disable react/prop-types */
import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
const { TextField } = MaterialUiCore;

function InputTextField(props) {
    const { label, filterName, updateParentState, ...rest } = props;
    const [val, setVal] = React.useState('');

    const handleChange = (event) => {
        setVal(event.target.value);
        updateParentState(filterName, event.target.value);
    };

    return (
        <TextField
            type="text"
            label={label}
            className="fullWidth"
            variant="outlined"
            value={val}
            onChange={handleChange}
            {...rest}
        />
    );
}

function InputNumberField(props) {
    const { label, filterName, updateParentState, ...rest } = props;
    const [numberVal, setNumberVal] = React.useState(0);

    const handleChange = (event) => {
        setNumberVal(event.target.value);
        updateParentState(filterName, event.target.value);
    };

    return (
        <TextField
            type="number"
            label={label}
            className="fullWidth"
            variant="outlined"
            value={numberVal}
            onChange={handleChange}
            {...rest}
        />
    );
}

export { InputTextField, InputNumberField };
